import { createSlice } from "@reduxjs/toolkit";
import { getConfigDetails } from "./keyThunk";

const keySlice = createSlice({
    name: "key",
    initialState: { keys: {}, loading: false, error: null },
    reducers: {
      clearSecretKeys: (state) => {
        state.keys = {}; 
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(getConfigDetails.pending, (state) => {
          state.loading = true;
        })
        .addCase(getConfigDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.keys = action.payload; 
        })
        .addCase(getConfigDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    },
  });
  
  export const { clearSecretKeys } = keySlice.actions;
  export default keySlice.reducer;
  
